import type { Listing } from '../api';

export const LISTING_CONDITION_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'All' },
  { value: 'new', label: 'New' },
  { value: 'new_open_box', label: 'New – Open box' },
  { value: 'seller_refurbished', label: 'Seller refurbished' },
  { value: 'used', label: 'Used' },
  { value: 'for_parts', label: 'For parts or not working' },
];

export const LISTING_SELLER_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'All' },
  { value: 'store', label: 'Store' },
  { value: 'owner', label: 'Owner' },
];

export function applyHomeBrowseFilters(
  list: Listing[],
  opts: {
    minPrice: string;
    maxPrice: string;
    condition: string;
    sellerType: string;
  },
): Listing[] {
  let result = list;
  const minP = parseFloat(opts.minPrice.trim());
  if (!Number.isNaN(minP) && minP > 0) {
    result = result.filter((l) => (l.price ?? 0) >= minP);
  }
  const maxP = parseFloat(opts.maxPrice.trim());
  if (!Number.isNaN(maxP) && maxP > 0) {
    result = result.filter((l) => (l.price ?? 0) <= maxP);
  }
  if (opts.condition) {
    result = result.filter((l) => (l.condition || 'new') === opts.condition);
  }
  if (opts.sellerType === 'store') {
    result = result.filter(
      (l) => l.store_id != null || Boolean(l.store_name?.trim()),
    );
  } else if (opts.sellerType === 'owner') {
    result = result.filter(
      (l) => l.store_id == null && !l.store_name?.trim(),
    );
  }
  return result;
}

export function countHomeBrowseFilters(opts: {
  category: string;
  minPrice: string;
  maxPrice: string;
  condition: string;
  sellerType: string;
}): number {
  return [
    opts.category,
    opts.minPrice,
    opts.maxPrice,
    opts.condition,
    opts.sellerType,
  ].filter(Boolean).length;
}
